import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=52ce8cb0&scoped=true&"
var script = {}
import style0 from "./Help.vue?vue&type=style&index=0&id=52ce8cb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ce8cb0",
  null
  
)

export default component.exports